/* __next_internal_client_entry_do_not_use__ SignUpButton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { popSignUp, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { trackSignupOpenBrandpageMainCtaClick } from "@faire/web-api--source/events/signup/click/openBrandpageMainCta";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
export var SignUpButton = function(props) {
    var brandToken = props.brandToken, element = props.element, sourceId = props.sourceId, children = props.children, rest = _object_without_properties(props, [
        "brandToken",
        "element",
        "sourceId",
        "children"
    ]);
    var isSSR = useIsSSR();
    var history = useHistory();
    var handleSignUp = function(e) {
        e.preventDefault();
        popSignUp(history, SignUpType.BRAND, trackSignupOpenBrandpageMainCtaClick, {
            element: element,
            sourceId: sourceId
        }, {
            brand: brandToken
        });
    };
    return /*#__PURE__*/ _jsx(StyledButton, _object_spread_props(_object_spread({
        onClick: handleSignUp,
        "data-test-id": "brand-sign-up-button",
        // We set a link for graceful degredation in SSR.
        linkTo: isSSR ? getCurrentPath().replace({
            signUp: "brand",
            brand: brandToken
        }).toString() : undefined
    }, rest), {
        children: children
    }));
};
var StyledButton = styled(Button).withConfig({
    componentId: "sc-9760afbd-0"
})([
    "width:fit-content;"
]);
